import { forwardRef, useImperativeHandle, useState } from "react"
import { IoClose } from "react-icons/io5"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import { buddiesInfoProps } from "@letshang/constants"
import { get } from "lodash-es"

import IconCalendar from "@fuse/assets/images/People/img-icon-calendar.svg"
import IconTicket from "@fuse/assets/images/People/img-icon-ticket.svg"

export interface ProfileModalHandle {
  openModal: (buddy: buddiesInfoProps) => void
  closeModal: () => void
}

const ProfileModal = forwardRef<ProfileModalHandle>((_, ref) => {
  const [isVisible, setIsVisible] = useState(false)
  const [selectedBuddy, setSelectedBuddy] = useState<buddiesInfoProps | null>(
    null,
  )

  // Expose methods to parent via ref
  useImperativeHandle(ref, () => ({
    openModal: (buddy: buddiesInfoProps) => {
      setSelectedBuddy(buddy)
      setIsVisible(true)
    },
    closeModal: () => {
      setIsVisible(false)
    },
  }))

  if (!isVisible || !selectedBuddy) return null

  const avatarUrl = get(
    selectedBuddy,
    "avatarUrl",
    get(selectedBuddy, "photoUrl", ""),
  )
  const name = get(selectedBuddy, "name", "")
  const joinedDate = get(selectedBuddy, "joinedDate", "")
  const sharedEventsCount = get(selectedBuddy, "sharedEventsCount", 0)

  return (
    <div
      className="fixed inset-0 flex justify-center bg-black bg-opacity-50 z-50 items-end md:items-center place-items-center"
      onClick={() => setIsVisible(false)}
    >
      <BlurWrapper
        overlayOpacityDefault="20"
        className="w-full md:max-w-sm bg-white rounded-t-2xl md:rounded-2xl p-6 relative flex flex-col cursor-auto place-content-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="absolute top-4 right-4 h-8 w-8 rounded-full blurTypeLight border-white/35 border flex items-center justify-center cursor-pointer"
          onClick={() => setIsVisible(false)}
        >
          <IoClose className="text-white text-xl" />
        </div>

        <div className="flex flex-col items-center text-center mt-4">
          <img
            src={avatarUrl}
            alt="Profile"
            className="w-16 h-16 rounded-full object-cover mb-2"
          />

          <h2 className="text-lg font-medium text-white mb-1">{name}</h2>
        </div>

        <div className="h-[0.1px] w-full bg-white35 my-6" />

        <div className="flex items-center gap-2 text-sm mb-2 text-white">
          <img src={IconCalendar} alt="IconCalendar" className="h-8 w-8" />
          Joined {joinedDate || "unknown"}
        </div>
        <div className="flex items-center gap-2 text-sm mb-2 text-white">
          <img src={IconTicket} alt="IconTicket" className="h-8 w-8" />
          You shared {sharedEventsCount != null ? sharedEventsCount : 0} events
        </div>
      </BlurWrapper>
    </div>
  )
})

export default ProfileModal
